<template>
  <Layout>
    <!--导航栏-->
    <Sider ref="side"
           class="layout-sider">
      <div class="sider-header">
        <img src="../assets/logo.png" style="width: 170px">
      </div>
      <Menu ref="menu"
            accordion
            theme="dark"
            width="auto"
            @on-select="menuSelect"
            :open-names="openNames"
            :active-name="activeName">
        <Submenu :name="item.fName"
                 v-for="item in menulist"
                 :key="item.fID"
                 v-if="item.hasRight===1">
          <template slot="title">
            <label>{{item.fName}}</label>
          </template>
          <MenuItem :name="subList.fLink"
                    v-for="subList in item.childList"
                    :key="subList.fID"
                    v-if="subList.hasRight===1">
            <label>{{subList.fName}}</label>
          </MenuItem>
        </Submenu>
      </Menu>
    </Sider>
    <Layout>
      <!--标题栏-->
      <Header class="layout-header">
        <h1>亚略特可信身份认证服务平台</h1>
        <div class="content">
          <h4 class="content-user">
            <img src="../assets/main/user.png"/>
            <Dropdown @on-click="dropdown"
                      trigger="click">
              <label class="title">{{username}}&nbsp;&nbsp;<Icon type="arrow-down-b"></Icon></label>
              <DropdownMenu slot="list">
                <DropdownItem divided
                              name="0">个人信息修改</DropdownItem>
                <DropdownItem divided
                              name="1">密码修改</DropdownItem>
                <DropdownItem divided
                              name="2">退出登录</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </h4>
          <h4 class="content-about">
            <Icon style="margin-right: 6px" size="26" type="ios-expand" />
            <label class="title" @click="visualization">综合视图</label>
          </h4>
          <h4 class="content-about">
            <img src="../assets/main/about.png"/>
            <label class="title" @click="about">关于</label>
          </h4>

        </div>
        <Modal v-model="model.show"
               :title="model.title"
               :styles="{top:'240px'}"
               @on-cancel="cancel">
          <Form ref="formPass"
                :model="form"
                :rules="ruleValidate">
            <FormItem prop="oldPassWord">
              <Input v-model.trim="form.oldPassWord" placeholder="请输入原密码" type="password"><span slot="prepend" class="model-form-head model-form-head-valid">原密码</span></Input>
            </FormItem>
            <FormItem prop="fPassWord">
              <Input v-model.trim="form.fPassWord" placeholder="请输入新密码" type="password"><span slot="prepend" class="model-form-head model-form-head-valid">新密码</span></Input>
            </FormItem>
            <FormItem prop="fRePassWord">
              <Input v-model.trim="form.fRePassWord" placeholder="请输入确认密码" type="password"><span slot="prepend" class="model-form-head model-form-head-valid">确认密码</span></Input>
            </FormItem>
          </Form>
          <div slot="footer">
            <Button type="success" @click="confirm">确定</Button>
            <Button type="default" @click="cancel" class="model-btn">退出</Button>
          </div>
        </Modal>
        <Modal v-model="personModel.show"
               :title="personModel.title"
               :styles="{top:'240px'}"
               @on-cancel="cancel">
          <Form ref="form"
                :model="form"
                :rules="ruleValidate">
            <FormItem prop="fNumber">
              <Input v-model.trim="form.fNumber" placeholder="请输入编号" disabled><span slot="prepend" class="model-form-head model-form-head-valid">编号</span></Input>
            </FormItem>
            <FormItem prop="fName">
              <Input v-model.trim="form.fName" placeholder="请输入名称" disabled><span slot="prepend" class="model-form-head model-form-head-valid">名称</span></Input>
            </FormItem>
            <FormItem prop="fEmail">
              <Input v-model.trim="form.fEmail" placeholder="请输入用户邮箱"><span slot="prepend" class="model-form-head">邮箱</span></Input>
            </FormItem>
            <FormItem prop="fMobile">
              <Input v-model.trim="form.fMobile" placeholder="请输入用户手机号"><span slot="prepend" class="model-form-head">手机号</span></Input>
            </FormItem>
            <FormItem prop="fQQ">
              <Input v-model.trim="form.fQQ" placeholder="请输入用户QQ号"><span slot="prepend" class="model-form-head">QQ</span></Input>
            </FormItem>
            <FormItem prop="fWeiXin">
              <Input v-model.trim="form.fWeiXin" placeholder="请输入用户微信号"><span slot="prepend" class="model-form-head">微信</span></Input>
            </FormItem>
          </Form>
          <div slot="footer">
            <i-button type="success"
                      @click="personConfirm">确定</i-button>
            <i-button type="default"
                      @click="personCancel"
                      class="model-btn">退出</i-button>
          </div>
        </Modal>
        <Modal v-model="aboutModel.show"
               :title="aboutModel.title"
               :styles="{top:'240px'}">
          <Card>
            <p>
              <label class="about-header">系统名称:</label><span class="about-body">亚略特可信身份认证服务平台</span>
            </p>
            <p>
              <label class="about-header">系统版本:</label><span class="about-body">V1.0.0</span>
            </p>
            <p>
              <label class="about-header">开发公司:</label><span class="about-body">深圳市亚略特科技股份有限公司</span>
            </p>
          </Card>
          <div slot="footer">
          </div>
        </Modal>
      </Header>
      <Content class="layout-content">
        <Tabs type="card"
              @on-tab-remove="handleTabRemove"
              :animated="true"
              :value="activeTab"
              @on-click="handleTabClick">
           <!--<TabPane name="首页"
             label="首页">
           </TabPane>-->
          <TabPane v-for="(item,i) in tabList"
                   :key="item.fLink + i"
                   :label="item.fName"
                   :name="item.fName"
                   closable>
          </TabPane>
        </Tabs>
        <keep-alive :include="currentAlive">
          <router-view></router-view>
        </keep-alive>
      </Content>
      <Footer class="layout-footer">Copyright&copy; 2019 深圳市亚略特科技股份有限公司 . &nbsp;&nbsp;&nbsp;&nbsp;All rights reserved</Footer>
    </Layout>
  </Layout>
</template>

<script>
import Home from '../components/Home'
import {
  checkUnusualChar,
  checkMobile
} from '../utils/validate'
import md5 from 'js-md5'
export default {
  name: "Main",
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('密码不得为空！'));
      } else {
        if (this.form.fRePassWord !== '') {
          // 对第二个密码框单独验证
          this.$refs.formPass.validateField('fRePassWord');
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('确认密码不得为空！'));
      } else if (value !== this.form.fPassWord) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    };
    return {
      username: JSON.parse(sessionStorage.getItem("user_info")).fName,
      menulist: [],
      subMenuList: [],
      tabList: [],
      activeTab: '', //激活的tab
      openNames: [],
      activeName: '', //激活的menu
      aliveRoute: [{
        name: 'sales_edit',
        title: '销售编辑',
        route: 'SalesEdit'
      }], //允许缓存的路由
      currentAlive: [], //当前激活缓存的路由
      model: {
        show: false,
        title: "",
      },
      form: {},
      personModel: {
        title: "",
        show: false,
      },
      aboutModel: {
        title: "",
        show: false,
      },
      ruleValidate: {
        oldPassWord: [{
          required: true,
          message: '数据项不得为空！',
          trigger: 'change'
        }, {
          type: 'string',
          max: 100,
          message: '最大长度不能超过100个字符！',
          trigger: 'change'
        }, {
          validator: checkUnusualChar,
          trigger: 'change'
        }, ],
        fPassWord: [{
          required: true,
          message: '数据项不得为空！',
          trigger: 'change'
        }, {
          type: 'string',
          max: 100,
          message: '最大长度不能超过100个字符！',
          trigger: 'change'
        }, {
          validator: checkUnusualChar,
          trigger: 'change'
        }, {
          validator: validatePass,
          trigger: 'change'
        }, ],
        fRePassWord: [{
          required: true,
          message: '数据项不得为空！',
          trigger: 'change'
        }, {
          type: 'string',
          max: 100,
          message: '最大长度不能超过100个字符！',
          trigger: 'change'
        }, {
          validator: checkUnusualChar,
          trigger: 'change'
        }, {
          validator: validatePassCheck,
          trigger: 'change'
        }, ],
        fNumber: [{
          required: true,
          message: '数据项不得为空！',
          trigger: 'change'
        }, {
          type: 'string',
          max: 80,
          message: '编号最大长度不能超过80个字符！',
          trigger: 'change'
        }, {
          validator: checkUnusualChar,
          trigger: 'change'
        }, ],
        fName: [{
          required: true,
          message: '数据项不得为空！',
          trigger: 'change'
        }, {
          type: 'string',
          max: 100,
          message: '最大长度不能超过100个字符！',
          trigger: 'change'
        }, {
          validator: checkUnusualChar,
          trigger: 'change'
        }, ],
        fEmail: [{
          type: 'string',
          max: 100,
          message: '最大长度不能超过100个字符！',
          trigger: 'change'
        }, {
          type: 'email',
          message: '无效的邮箱格式！',
          trigger: 'change'
        }, ],
        fMobile: [{
          validator: checkMobile,
          trigger: 'change'
        }, ],
        fQQ: [{
          type: 'string',
          max: 30,
          message: '最大长度不能超过30个字符！',
          trigger: 'change'
        }, {
          validator: checkUnusualChar,
          trigger: 'change'
        }, ],
        fWeiXin: [{
          type: 'string',
          max: 80,
          message: '最大长度不能超过80个字符！',
          trigger: 'change'
        }, {
          validator: checkUnusualChar,
          trigger: 'change'
        }, ],
      },
      setparam: '',
      link: true,
    }
  },
  watch: {
    $route(route) {
      this.updateMenu(route)
      // 插入允许缓存的路由
      this.aliveRoute.some(item => {
        if (item.name === route.name && this.currentAlive.indexOf(item.route) < 0) {
          this.currentAlive.push(item.route)
          return true
        }
      })
    }
  },
  created() {
    this.tabList = this.$store.state.tagsList
    this.getUserMenuList()
  },
  methods: {
    visualization() {
      this.$router.push({
        path: "/visualization",
      });
    },
    //获取菜单树
    getUserMenuList() {
      const api = {
        url: '/menu/selectMenuTreeByCurrentUser',
        method: 'get'
      }
      this.$api(api).then(response => {
        if (response.data.code === '0') {
          if (response.data.data.length > 0) {
            const rightcodelist = []
            this.menulist = response.data.data[0].childList
            this.menulist.forEach(item => {
              // item.fIcon = 'iconfont icon-'+item.fIcon;
              if (item.childList) {
                this.subMenuList = this.subMenuList.concat(item.childList)
              }
            })
            this.updateMenu(this.$route)
          }
        } else {
          this.$Modal.error({
            content: response.data.message
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 更新菜单标签
    updateMenu(route) {
      let has = this.tabList.some(item => {
        if (item.fName === route.meta.title) {
          item.fNumber = route.params.fNumber
          return true
        } else {
          return false
        }
      })
      if (!has && route.name !== 'home') {
        this.$store.commit('createTag', {
          fNumber: route.params.fNumber,
          fLink: route.name,
          fName: route.meta.title
        })
      }
      this.activeTab = route.meta.title
      this.openNames = []
      this.activeName = ''
      this.menulist.some(menu => {
        if (menu.fName === route.matched[0].meta.title) {
          this.openNames.push(menu.fName)
          this.activeName = route.name.replace('_edit', '_list')
          return true
        }
      })
      this.$nextTick(() => {
        this.$refs.menu.updateOpened()
        this.$refs.menu.updateActiveName()
      })
    },
    //点击菜单事件
    menuSelect(link) {
      if (link === 'apitest') {
        let routeData = this.$router.resolve({
          name: "apitest",
        });
        window.open(routeData.href, '_blank');
        return
      }
      this.subMenuList.some(item => {
        if (item.fLink === link) {
          !this.tabList.some(tab => tab.fLink === link) && this.$store.commit('createTag', {
            fLink: item.fLink,
            fName: item.fName
          })
          this.$router.push({
            name: item.fLink
          })
          return true
        }
      });
    },
    //tab标签页移除切换
    handleTabRemove(name) {
      this.$store.commit('removeTag', name)
      if (this.tabList.length > 0) {
        if (name !== this.activeTab) {
          return
        }
        this.handleTabClick(this.tabList[this.tabList.length - 1].fName)
      } else {
        this.handleTabClick('首页')
      }
      // 清除已缓存的路由
      this.aliveRoute.some(item => {
        if (item.title === name) {
          this.currentAlive.splice(this.currentAlive.indexOf(item.route), 1)
          return true
        }
      })
    },
    //点击tab标签页
    handleTabClick(name) {
      if (name === this.activeTab) {
        return
      }
      if (name === '首页') {
        this.$router.push({
          name: 'home'
        })
        this.activeTab = '首页'
      } else {
        this.tabList.some(item => {
          if (item.fName === name) {
            this.$router.push({
              name: item.fLink,
              params: {
                fNumber: item.fNumber
              }
            })
            return true
          }
        })
      }
    },
    dropdown(data) {
      if (data === "0") {
        //个人信息修改
        this.personModel.show = true;
        this.personModel.title = "个人信息修改";
        this.$refs.form.resetFields();
        this.form = {};
        this.getUserInfo();
      } else if (data === "1") {
        //密码修改
        this.model.show = true;
        this.model.title = "密码修改";
        this.$refs.formPass.resetFields();
        this.form = {};
      } else {
        this.logout();
      }
    },
    //获取用户信息
    getUserInfo() {
      const api = {
        url: '/user/selectUserByID',
        method: 'get',
      };
      this.$api(api).then(response => {
        if (response.status === 200 && response.data.code === '0') {
          this.form = response.data.data;
        } else {
          this.$Message.error({
            content: error.response.data.message,
          });
        }
      }).catch(error => {
        this.$Message.error({
          content: error.response.data.message,
        });
      });
    },
    confirm() {
      this.$refs.formPass.validate((valid) => {
        this.form.fRePassWord = null;
        this.form.oldPassWord = md5(this.form.oldPassWord);
        this.form.fPassWord = md5(this.form.fPassWord);
        this.form.fName = this.username;
        if (valid) {
          const api = {
            url: '/user/updateUserPassword',
            method: 'post',
            data: this.form,
          };
          this.$api(api).then(response => {
            if (response.status === 200 && response.data.code === '0') {
              this.model.show = false;
              this.$Message.success({
                content: response.data.message,
              });
              let data = {
                fName: this.form.fName,
                fPassWord: this.form.fPassWord,
              };
              sessionStorage.setItem("user_info", JSON.stringify(data));
            } else {
              this.$refs.form.resetFields();
              this.form = {};
              this.$Message.error({
                content: response.data.message,
              });
            }
          }).catch(error => {
            this.$refs.form.resetFields();
            this.form = {};
            this.$Message.error({
              content: error.response.data.message,
            });
          });
        } else {
          return;
        }
      });
    },
    cancel() {
      this.model.show = false;
      this.$refs.formPass.resetFields();
      this.form = {};
    },
    personConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const api = {
            url: '/user/updateCurrentUserInfo',
            method: 'post',
            data: this.form,
          };
          this.$api(api).then(response => {
            if (response.status === 200 && response.data.code === '0') {
              this.personModel.show = false;
              this.$Message.success({
                content: response.data.message,
              });
            } else {
              this.$Message.error({
                content: response.data.message,
              });
            }
          }).catch(error => {
            this.$Message.error({
              content: error.response.data.message,
            });
          });
        } else {
          return;
        }
      });
    },
    personCancel() {
      this.personModel.show = false;
      this.$refs.form.resetFields();
      this.form = {};
    },
    //退出登录
    logout() {
      const api = {
        url: '/logout',
        method: 'post',
      };
      this.$api(api).then(response => {
        if (response.status === 200 && response.data.code === '0') {
          sessionStorage.clear();
          this.$router.push({
            name: 'login'
          });
        } else {
          this.$Modal.error({
            content: response.data.message,
          });
        }
      }).catch(error => {
        this.$Modal.error({
          content: error.response.data.message,
        });
      });
    },
    //设置
    setting() {
      this.menuSelect(this.setparam);
    },
    //关于
    about() {
      this.aboutModel.show = true;
      this.aboutModel.title = "关于";
    },
  },
  components: {
    home: Home,
  }
}
</script>

<!--<style lang="scss">-->
<!--.model-form-head {-->
<!--  display: inline-block;-->
<!--  width: 55px;-->
<!--}-->

<!--.model-form-head-valid {-->
<!--  position: relative;-->
<!--  bottom: 2px;-->
<!--}-->

<!--.model-form-head-valid:before {-->
<!--  content: "*";-->
<!--  color: #ff4949;-->
<!--  margin-right: 2px;-->
<!--  font-size: 20px;-->
<!--  position: relative;-->
<!--  top: 7px;-->
<!--}-->

<!--.ivu-table-fixed,-->
<!--.ivu-table-fixed-right {-->
<!--  box-shadow: none;-->
<!--}-->

<!--.ivu-checkbox-indeterminate .ivu-checkbox-inner {-->
<!--  background-color: #19be6b;-->
<!--  border-color: #19be6b;-->
<!--}-->

<!--.about-header {-->
<!--  margin-right: 15px;-->
<!--  margin-top: 15px;-->
<!--  width: 80px;-->
<!--  font-size: 16px;-->
<!--  font-weight: bolder;-->
<!--  display: inline-block;-->
<!--  text-align: right;-->
<!--}-->

<!--.about-body {-->
<!--  font-size: 16px;-->
<!--  display: inline-block;-->
<!--  text-align: left;-->
<!--}-->

<!--.layout {-->
<!--  width: 100%;-->
<!--  position: absolute;-->

<!--  .ivu-layout {-->
<!--    background: #e1e3e6;-->
<!--  }-->

<!--  .layout-sider {-->
<!--    min-height: 974px;-->
<!--    min-width: 225px !important;-->
<!--    background: url("../assets/main/slider.png") no-repeat;-->

<!--    .sider-header {-->
<!--      img {-->
<!--        margin: 50px 22px;-->
<!--      }-->
<!--    }-->

<!--    .ivu-menu-dark {-->
<!--      background: none;-->
<!--    }-->

<!--    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {-->
<!--      background: rgba(0, 0, 0, 0.2);-->
<!--    }-->

<!--    /*.menu-item span{-->
<!--        display: inline-block;-->
<!--        overflow: hidden;-->
<!--        width: 90px;-->
<!--        text-overflow: ellipsis;-->
<!--        white-space: nowrap;-->
<!--        vertical-align: bottom;-->
<!--        transition: width .2s ease .2s;-->
<!--      }-->
<!--      .menu-item i{-->
<!--        transform: translateX(0px);-->
<!--        transition: font-size .2s ease, transform .2s ease;-->
<!--        vertical-align: middle;-->
<!--        font-size: 18px;-->
<!--      }*/-->
<!--    .ivu-menu-submenu-title {-->
<!--      img {-->
<!--        margin-right: 5px;-->
<!--        width: 20px;-->
<!--        height: 20px;-->
<!--        display: inline-block;-->
<!--        vertical-align: middle;-->
<!--      }-->

<!--      label {-->
<!--        display: inline-block;-->
<!--        vertical-align: middle;-->
<!--      }-->
<!--    }-->
<!--  }-->

<!--  .layout-header {-->
<!--    background: #e1e3e6;-->
<!--    height: 45px;-->
<!--    display: flex;-->
<!--    justify-content: space-between;-->
<!--    border-bottom: 1px dashed #666;-->

<!--    h1 {-->
<!--      font-size: 20px;-->
<!--      color: #646566;-->
<!--      line-height: 45px;-->
<!--    }-->

<!--    .content {-->
<!--      display: flex;-->
<!--      justify-content: space-between;-->
<!--      align-items: center;-->

<!--      h4 {-->
<!--        color: #32373d;-->
<!--        font-size: 14px;-->
<!--        font-weight: normal;-->
<!--        margin-left: 30px;-->
<!--        display: flex;-->
<!--        align-items: center;-->
<!--        height: 45px;-->

<!--        img {-->
<!--          margin-right: 8px;-->
<!--        }-->

<!--        .title:hover {-->
<!--          cursor: pointer;-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->

<!--  .layout-content {-->
<!--    margin-top: 16px;-->
<!--    margin-left: 20px;-->
<!--    margin-right: 20px;-->

<!--    .ivu-tabs-bar {-->
<!--      border-bottom: 1px solid #ccc;-->
<!--      margin-bottom: 0 !important;-->
<!--    }-->
<!--  }-->

<!--  .layout-footer {-->
<!--    background: #e1e3e6;-->
<!--    font-size: 12px;-->
<!--    text-align: center;-->
<!--    color: #323233;-->
<!--    border-top: 1px solid #ccc;-->
<!--    height: 32px;-->
<!--    padding: 0;-->
<!--    line-height: 32px;-->
<!--  }-->
<!--}-->
<!--</style>-->

<style lang="scss">
  .model-form-head {
    display: inline-block;
    width: 55px;
  }

  .model-form-head-valid {
    position: relative;
    bottom: 2px;
  }

  .model-form-head-valid:before {
    content: "*";
    color: #ff4949;
    margin-right: 2px;
    font-size: 20px;
    position: relative;
    top: 7px;
  }

  .ivu-table-fixed,
  .ivu-table-fixed-right {
    box-shadow: none;
  }

  .ivu-checkbox-indeterminate .ivu-checkbox-inner {
    background-color: #19be6b;
    border-color: #19be6b;
  }

  .about-header {
    margin-right: 15px;
    margin-top: 15px;
    width: 80px;
    font-size: 16px;
    font-weight: bolder;
    display: inline-block;
    text-align: right;
  }

  .about-body {
    font-size: 16px;
    display: inline-block;
    text-align: left;
  }


  .ivu-layout {
    background: #e1e3e6;
    height: 100%;
  }

  .layout-sider {
    min-width: 225px !important;
    background: url("../assets/main/slider.png") no-repeat;

    .sider-header {
      img {
        margin: 50px 22px;
      }
    }

    .ivu-menu-dark {
      background: none;
    }

    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
      background: rgba(0, 0, 0, 0.2);
    }

    /*.menu-item span{
        display: inline-block;
        overflow: hidden;
        width: 90px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
      }
      .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 18px;
      }*/
    .ivu-menu-submenu-title {
      img {
        margin-right: 5px;
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
      }

      label {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  .layout-header {
    background: #e1e3e6;
    height: 45px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #666;

    h1 {
      font-size: 20px;
      color: #646566;
      line-height: 45px;
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h4 {
        color: #32373d;
        font-size: 14px;
        font-weight: normal;
        margin-left: 30px;
        display: flex;
        align-items: center;
        height: 45px;

        img {
          margin-right: 8px;
        }

        .title:hover {
          cursor: pointer;
        }
      }
    }
  }

  .layout-content {
    margin-top: 16px;
    margin-left: 15px;
    margin-right: 15px;

    .ivu-tabs-bar {
      border-bottom: 1px solid #ccc;
      margin-bottom: 0 !important;
    }
  }

  .layout-footer {
    background: #e1e3e6;
    font-size: 12px;
    text-align: center;
    color: #323233;
    border-top: 1px solid #ccc;
    height: 32px;
    padding: 0;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Main.vue